import React from 'react';
import {getHousingPicture, getHousingName} from 'utils/reservation';
import {useReservation} from 'context/reservation';
import propertyDefaultImage from 'assets/img/general-pic-booking-details.jpg';
import propertyDefaultImage2x from 'assets/img/general-pic-booking-details@2x.jpg';
import styles from './BookingDetails.module.sass';
import {DatesAndGuestsBoxStyled} from '../BookingStatus/styled';

function BookingDetails() {
  const {data: reservation} = useReservation();

  const propertyName = getHousingName(reservation);
  const propertyPicture = getHousingPicture(reservation);

  const picture = propertyPicture || propertyDefaultImage;
  const picture2x = propertyPicture || propertyDefaultImage2x;

  return (
    <div className={styles.content}>
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <img
          className={styles.propertyPhoto}
          src={picture}
          alt="Property"
          width={384}
          height={217}
          srcSet={`${picture} 1x, ${picture2x} 2x`}
        />
      </div>
      <div className={styles.propertyName}>{propertyName}</div>
      <DatesAndGuestsBoxStyled />
    </div>
  );
}

export {BookingDetails};
